module.exports = __webpack_public_path__ + "img/phone.757314e2.png";